import { Box } from "@mui/material";
import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import {
  tableList,
  headTitleList1,
  headTitleList2,
  headListWorkingDayNum,
} from "./parts";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkTable from "../../components/atoms/TkTable";
import TkTitle from "../../components/atoms/TkTitle";
import TkBackButton from "../../components/molecules/TkBackButton";
import { httpAPI_STA003, httpAPI_RET007 } from "./api/request";
import { TkGetCode } from "../../utils/TkGetCode";
import {
  FormClassRetire,
  HalfYearExtensionReason,
  OtherBenefitsFlg,
  PapaMamaPlus,
  Prefectures,
  RetireFlowReason,
  RetirementInvoiceOrder,
  RetireReason,
  WithholdingSlipKbn,
  YesOrNoFlug,
} from "../../assets/data/Constants";
import { changeAmountFormat, changeZipcodeFormat } from "../../utils/useTools";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import { toNumberOrUndefined } from "../../utils/useTools";
import _ from "lodash";

/**
 * SCRC060132 退職届の取り下げ
 * @return SCRC060132 退職届の取り下げ
 */
const SCRC060132 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  let locationState = location.state;
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);

  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isKiko
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo;

  const [stateTableList, setStateTableList] = useState(_.cloneDeep(tableList));
  const [status, setStatus] = useState("");
  const [open, setOpen] = useState(false);
  const [originalApplyId, setOriginalApplyId] = useState(0);
  const [retireProcedureReason, setRetireProcedureReason] = useState("");
  const [businessType, setBusinessType] = useState<any>();

  async function handleInit() {
    let resArr = stateTableList;

    let contractorName = resArr.find(
      (item) => item.keyword === "contractorName"
    )!;
    contractorName.contractorNumber =
      businessState.common?.contractorNo +
      ":" +
      businessState.common?.contractorName;
    contractorName.showLine = isKiko;

    try {
      const res = await httpAPI_STA003({
        contractorNo,
        staffNo: locationState?.staffNo,
        applyId: locationState?.applyId,
      });

      if (res.resultCd === "I0000") {
        for (let index in res) {
          let i = index as keyof typeof res;
          let targetObj = resArr.find((item) => item.keyword === i)!;

          if (targetObj) {
            if (targetObj.keyword?.includes("Kbn")) {
              targetObj.text = TkGetCode(WithholdingSlipKbn, res[i]);
              continue;
            }
            if (targetObj.keyword?.includes("Amt")) {
              targetObj.text =
                changeAmountFormat(toNumberOrUndefined(res[i]) ?? 0) + "円";
              continue;
            }
            if (targetObj.keyword?.includes("LengthOfService")) {
              targetObj.text = res[i] + "年";
              continue;
            }
            if (targetObj.keyword?.includes("DeductionPeriodYear")) {
              targetObj.text = res[i] ? res[i] + "年" : "";
              continue;
            }
            if (targetObj.keyword?.includes("DeductionPeriodMonth")) {
              targetObj.text = res[i] ? res[i] + "月" : "";
              continue;
            }

            if (targetObj.type === "text") {
              targetObj.text = res[i];
            } else {
              targetObj.setDefaultValue = res[i];
            }
          }
        }

        if (res.businessType === "JOB-33") {
          // 現在の共済契約者と転職先の共済契約者が、施設運営上の理由により人材を融通することを事前に合意した転職である
          let continueTransferApplicable1Flg = resArr.find(
            (item) => item.keyword === "continueTransferApplicable1Flg"
          )!;
          continueTransferApplicable1Flg.text =
            !res?.continueTransferApplicable1Flg ||
            res?.continueTransferApplicable1Flg === "" ||
            res?.continueTransferApplicable1Flg === "0"
              ? ""
              : "該当";

          continueTransferApplicable1Flg.showLine = true;
          // 現在の共済契約者の退職日の翌日が、転職先の共済契約者への就職日である
          let continueTransferApplicable2Flg = resArr.find(
            (item) => item.keyword === "continueTransferApplicable2Flg"
          )!;
          continueTransferApplicable2Flg.text =
            !res?.continueTransferApplicable2Flg ||
            res?.continueTransferApplicable2Flg === "" ||
            res?.continueTransferApplicable2Flg === "0"
              ? ""
              : "該当";
          continueTransferApplicable2Flg.showLine = true;
          // 転職先の共済契約者番号
          let aContractorNo = resArr.find(
            (item) => item.keyword === "aContractorNo"
          )!;
          aContractorNo.showLine = true;
          // 転職先の共済契約者名
          let contractorName = resArr.find(
            (item) => item.keyword === "aCorpName"
          )!;
          contractorName.showLine = true;
          // 転職先の共済契約者名
          let retireWorkingDayNum = resArr.find(
            (item) => item.keyword === "retireWorkingDayNum"
          )!;
          retireWorkingDayNum.text = (res.workingDayNum ?? 0) + "日";
          retireWorkingDayNum.showLine = true;
        }

        setStatus(res.latestApplyStatus ?? "");
        setRetireProcedureReason(
          TkGetCode(RetireFlowReason, res.retireProcedureReason) ?? ""
        );
        setOriginalApplyId(toNumberOrUndefined(res.applyId) ?? 0);
        setBusinessType(res.businessType);

        resArr.find((item) => item.keyword === "nRetireReasonCd")!.text =
          TkGetCode(RetireReason, res.nRetireReasonCd);
        resArr.find((item) => item.keyword === "retireProcedureReason")!.text =
          TkGetCode(RetireFlowReason, res.retireProcedureReason);
        resArr.find((item) => item.keyword === "zipcode")!.text =
          changeZipcodeFormat(res.zipcode);
        resArr.find((item) => item.keyword === "address")!.text =
          (TkGetCode(Prefectures, res.prefectureCd) ?? "") +
          (res.addressCity ?? "") +
          (res.addressOthers ?? "");

        const makecheckList = [];
        (res.apr === "1" || res.apr === "3") && makecheckList.push("4月");
        (res.may === "1" || res.may === "3") && makecheckList.push("5月");
        (res.jun === "1" || res.jun === "3") && makecheckList.push("6月");
        (res.jul === "1" || res.jul === "3") && makecheckList.push("7月");
        (res.aug === "1" || res.aug === "3") && makecheckList.push("8月");
        (res.sep === "1" || res.sep === "3") && makecheckList.push("9月");
        (res.oct === "1" || res.oct === "3") && makecheckList.push("10月");
        (res.nov === "1" || res.nov === "3") && makecheckList.push("11月");
        (res.dec === "1" || res.dec === "3") && makecheckList.push("12月");
        (res.jan === "1" || res.jan === "3") && makecheckList.push("1月");
        (res.feb === "1" || res.feb === "3") && makecheckList.push("2月");
        (res.mar === "1" || res.mar === "3") && makecheckList.push("3月");
        resArr.find((item) => item.keyword === "noMonth")!.setDefaultValue =
          makecheckList.length > 0 ? makecheckList : ["無"];

        const childcareList: any =
          res.childcareLeaveList?.map((item) => [
            {
              children: item.childcareLeaveSerialNo,
            },
            {
              children: item.birthday,
              align: "center",
            },
            {
              children: item.startDate,
              align: "center",
            },
            {
              children: item.endDate,
              align: "center",
            },
            {
              children: TkGetCode(PapaMamaPlus, item.papaMamaFlg),
              align: "center",
            },
            {
              children: TkGetCode(
                HalfYearExtensionReason,
                item.halfyearExtensionReason
              ),
            },
            {
              children: TkGetCode(YesOrNoFlug, item.papaChildcareLeaveFlg),
              align: "center",
            },
          ]) ?? [];
        resArr.find((item) => item.keyword === "childcareLeaveList")!.node = (
          <TkTable headList={headTitleList1} bodyList={childcareList} />
        );
        const childcareWorkingNumList: any =
          res.childcareLeaveWorkingDayNumList?.map((item) => [
            {
              children: `${(item.yearMonth + "").slice(0, 4)}/${(
                item.yearMonth + ""
              ).slice(4)}`,
              align: "center",
            },
            {
              children: `${item.workingDayNum?.toString()}日`, // 出勤日数
              align: "right",
            },
          ]) ?? [];
        resArr.find(
          (item) => item.keyword === "childcareActiveListList"
        )!.node = (
          <TkTable
            headList={headListWorkingDayNum}
            bodyList={childcareWorkingNumList}
          />
        );

        const salaryList: any =
          res.sixMonthsSalaryBeforeApplyList?.map((item) => {
            let allowances = res.sixMonthsSalaryBeforeApplyDetailList
              ?.filter((i) => i.yearMonth === item.yearMonth)
              ?.map(
                (item) =>
                  res.salaryAdjustmentAllowanceList?.find(
                    (i) => i.allowanceHisSerialNo === item.allowanceHisSerialNo
                  )?.allowanceName
              );
            return [
              {
                children: `
                ${item?.yearMonth?.toString()?.slice?.(0, 4)}年${item?.yearMonth
                  ?.toString()
                  ?.slice?.(4, 6)}月
              `,
              },
              {
                children: changeAmountFormat(item?.salaryTableAmt ?? 0) + "円",
                align: "right",
              },
              {
                children: allowances?.join("、"),
              },
              {
                children: `${changeAmountFormat(
                  item.salaryAdjustmentAmt ?? 0
                )}円`, //  俸給の調整額
                align: "right",
              },
            ];
          }) ?? [];
        resArr.find((item) => item.keyword === "sixMonthsSalaryList")!.node = (
          <TkTable
            headList={headTitleList2}
            bodyList={salaryList}
            headerLeftComponent={
              res.businessType === "JOB-33" ? (
                <TkTitle>{"本俸月額登録"}</TkTitle>
              ) : (
                <TkTitle>{"俸給状況"}</TkTitle>
              )
            }
          />
        );

        // 退職理由
        let retireReason = resArr.find(
          (item) => item.keyword === "retireReason"
        )!;
        retireReason.text = `${TkGetCode(RetireReason, res.nRetireReasonCd)}${
          res.retireProcedureReason
            ? "＆" + TkGetCode(RetireFlowReason, res.retireProcedureReason)
            : ""
        }`;

        const hasWageLedger = res.formList?.some(
          (i) => i.formClass === FormClassRetire["賃金台帳"]
        );
        // 添付書類
        resArr.forEach((item) => {
          if (
            res.nRetireReasonCd ===
            RetireReason["業務上の傷病又は業務上の死亡による退職"]
          ) {
            if (
              item.id === RetireFlowReason["傷病による退職"] ||
              item.id === RetireFlowReason["死亡による退職"]
            ) {
              item.showLine = res.retireProcedureReason === item.id;
            }
          }
          if (item.id === RetireReason["犯罪等による退職"]) {
            item.showLine = res.nRetireReasonCd === item.id;
          }
        });

        if (res.nRetireReasonCd === RetireReason["普通退職"]) {
          retireReason.showLine = false;
          if (!hasWageLedger) {
            resArr.find((item) => item.keyword === "title6")!.showLine = false;
            resArr.find(
              (item) => item.keyword === FormClassRetire["賃金台帳"]
            )!.showLine = false;
          }
        } else {
          retireReason.showLine = true;
          resArr.find((item) => item.keyword === "title6")!.showLine = true;
        }

        if (res.businessType === "JOB-33") {
          resArr.find((item) => item.keyword === "title8")!.showLine = false;
          resArr.find(
            (item) => item.keyword === "prefectureRetirementJoinFlg"
          )!.showLine = false;
          resArr.find(
            (item) => item.keyword === "retirementInvoiceOrder"
          )!.showLine = false;
          resArr.find((item) => item.keyword === "title9")!.showLine = false;
          resArr.find(
            (item) =>
              item.keyword ===
              FormClassRetire["退職所得の源泉徴収票_退職届1枚目"]
          )!.showLine = false;
        } else {
          // 福祉医療機構以外からの退職金受け取りの有無
          resArr.find(
            (item) => item.keyword === "prefectureRetirementJoinFlg"
          )!.text = TkGetCode(
            OtherBenefitsFlg,
            res.prefectureRetirementJoinFlg
          );
          // 退職手当金請求の順番
          resArr.find(
            (item) => item.keyword === "retirementInvoiceOrder"
          )!.text = TkGetCode(
            RetirementInvoiceOrder,
            res.retirementInvoiceOrder
          );

          // 1枚目/2枚目/3枚目区分が設定されている場合の表示処理
          resArr
            .filter((item) => item.id?.includes("page"))
            ?.forEach((item) => {
              res[`${item.id}Kbn` as keyof typeof res] &&
                (item.showLine = true);
            });
          res.formList?.forEach((item) => {
            let targetObj = resArr.find((i) => i.keyword === item.formClass)!;

            if (targetObj) {
              targetObj.dataname = item.formName;
              targetObj.base64filedata = item.fileBase64;
            }

            if (item.formClass === FormClassRetire["賃金台帳"]) {
              targetObj.showLine = !!targetObj;
            }
          });
        }

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }

      setStateTableList([...resArr]);
    } catch (error) {
      navigate("/error");
    }
  }

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const btnClick = async () => {
    if (isKiko) {
      setOpen(true);
    } else {
      dataOkClick();
    }
  };

  const dataOkClick = async (data?: any) => {
    try {
      const res = await httpAPI_RET007({
        originalApplyId: originalApplyId,
        originalBusinessType: businessType,
        contractorNo,
        reason: retireProcedureReason,
        receptionDate: data,
        screenId: "SCRC060132",
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC060031");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRC060132PageForTest" className="tkSCRC060132">
      <TkFakeTable
        list={stateTableList}
        ruleSchema={{}}
        submitButtonText="取下げ"
        showButton={status !== "00" && status !== "16" && status !== "15"}
        buttonGroup={<TkBackButton />}
        onCheckAndSubmit={btnClick}
      />

      <TkDateDialog
        open={open}
        onCancel={() => setOpen(false)}
        minDate={new Date("1900/01/01")}
        maxDate={new Date()}
        title="確認（機構へ取り下げます）"
        contextText="　取り下げしますか？"
        cancelText="いいえ"
        okText="はい"
        onOky={(data: any) => dataOkClick(data)}
      />
    </Box>
  );
};

export default SCRC060132;
